export const WORK_PROCESSES = {
  discussion: {
    title: '01 | Обсуждение проекта',
    mainText:
      'Знакомство с вами и на основе ваших преподчтений находим наиболее комфортное интерьерное решение',
    listItems: [
      'Заполнение брифа (стиль, бюджет, сроки, функциональные зоны).',
      'Выезд на объект, обмеры, фотофиксация, анализ инженерных сетей.',
    ],
  },
  conceptualDesign: {
    title: '02 | Концептуальное проектирование',
    mainText:
      'На основе ваших преподчтений, предоставляем несколько планировочныйх решений и после утверждённого эскизного проекта, разрабатываем его техническую и визуальную часть.',
    listItems: [
      'Разработка стилевого решения (moodboard, цветовая палитра).',
      'Планировочные решения (2-3 варианта).',
      '3D-визуализация ключевых зон.',
      'Согласование концепции с клиентом.',
    ],
  },
  development: {
    title: '03 | Разработка дизайна',
    mainText:
      'На этом этапе мы превращаем утверждённую концепцию в продуманный до мелочей проект. Всё, что было в общих чертах, теперь обретает точные формы, цвета и фактуры.',
    listItems: [
      'Создание более детализированных эскизов и моделей.',
      'Выбор цветовой палитры, материалов и текстур.',
    ],
  },
  documentation: {
    title: '04 | Создание проектной документации',
    mainText:
      'Считаем объёмы на материалы, рассчитываем стоимость работ, материалов и приступаем к реализации вашего проекта',
    listItems: [
      'Подготовка чертежей, спецификаций и документации для реализации проекта.',
      'Подбор всех необходимых подрядчиков и исполнителей.',
    ],
  },
  presentation: {
    title: '05 | Презентация проекта',
    mainText:
      'Финальное согласование перед реализацией. На этом этапе вы увидите готовый дизайн-проект во всех деталях и сможете внести последние правки перед началом ремонта.',
    listItems: ['Подготовка и представление проекта клиенту для одобрения.'],
  },
  implementation: {
    title: '06 | Реализация проекта',
    mainText:
      'Посещение вашего реализуемого оъекта с целью контроля исполнения качества этапов работ, при необходимости в чертеже вносим правки и корректируем документацию.',
    listItems: [
      'Координация работы с подрядчиками и поставщиками.',
      'Контроль за выполнением работ в соответствии с проектом.',
    ],
  },
}
